<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="user-activity-logs-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
  [gridOptionsOverrides]="gridOptionsOverrides"
  [onApplyExtraViewPresetSettings]="restoreDrillFilters"
></app-data-grid>
